import { bindActionCreators, compose } from 'redux';
import { connect, DropTargetCreator, featureOn, newHoverPosition, modalActions, moveTemporaryQuizEntry, moveQuizEntry, set as setUI, getActiveQuiz, createBulkItems, createBulkQuizEntries, addSuccess, addInfo } from '@instructure/quiz-core';
import { QUIZ_ENTRY_REF } from '@instructure/quiz-common';
import { BuildContent as BuildContentPresenter } from './presenter';
function mapStateToProps(state) {
  var activeQuiz = getActiveQuiz(state);
  var quizId = activeQuiz.id;
  var quizEntriesIncludingTemp = activeQuiz.getWorkingQuizEntries();
  return {
    dndPositionObj: state.get('dragAndDrop'),
    lockBlueprintContentEnabled: featureOn('lock_blueprint_content'),
    quizId: quizId,
    // needed for DND
    quiz: activeQuiz,
    isContentLockedByBlueprint: activeQuiz.originalQuizLockedByBlueprint,
    workingQuiz: activeQuiz.getWorkingInstance(),
    quizEntries: quizEntriesIncludingTemp,
    quizEntriesLoaded: activeQuiz.quizEntriesCount === 0 || !!state.getIn(['quizzes', quizId, 'quizEntries'])
  };
}
function mapDispatchToProps(dispatch) {
  return {
    moveQuizEntry: bindActionCreators(moveQuizEntry, dispatch),
    // Needed for DND
    moveTemporaryQuizEntry: bindActionCreators(moveTemporaryQuizEntry, dispatch),
    // Needed for DND
    newHoverPosition: bindActionCreators(newHoverPosition, dispatch),
    // Needed for DND
    openMoveImmutableModal: bindActionCreators(modalActions, dispatch).openMoveImmutableModal,
    // Needed for DND
    setUi: bindActionCreators(setUI, dispatch),
    // Needed for DND
    addSuccessAlert: bindActionCreators(addSuccess, dispatch),
    addInfoAlert: bindActionCreators(addInfo, dispatch),
    createBulkItems: bindActionCreators(createBulkItems, dispatch),
    createBulkQuizEntries: bindActionCreators(createBulkQuizEntries, dispatch)
  };
}

// BuildContent is a dropTarget to handle drops that occur on the page,
// but not directly on a quizEntry (such as at the top or bottom of the page).
// it also uses the isOver prop to conditionally render dropZones on Build vs Sidebar
export var BuildContent = compose(connect(mapStateToProps, mapDispatchToProps), DropTargetCreator(QUIZ_ENTRY_REF))(BuildContentPresenter);
export default BuildContent;